import React, { useEffect } from "react";
import Breadcrumb from "../Breadcrumb";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";

export default function TermsPage() {
  pageTitle("Terms & Conditions");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="Terms & Conditions"
        bgUrl="https://png.pngtree.com/thumb_back/fh260/background/20210814/pngtree-business-gradient-geometric-gray-square-abstract-simple-gray-background-image_759189.jpg"
      />

      <Section pt="120" pb="100">
        <div className="container">
          <div className="terms-content">
            <h2 className="fw-bold mb-4">Welcome to Riyansh Solar Power Plus!</h2>
            <p className="mb-4">
              By using our website and services, you agree to comply with these Terms & Conditions.
            </p>

            <h4 className="mt-4">Acceptance of Terms</h4>
            <p className="mb-3">
              By accessing our website, you agree to these Terms. If you do not agree, please do not use our services.
            </p>

            <h4 className="mt-4">Use of Our Services</h4>
            <ul className="mb-3 ps-3">
              <li>Our solar products and services are for legal and authorized purposes only.</li>
              <li>Any misuse, unauthorized modification, or fraudulent use of our services is prohibited.</li>
            </ul>

            <h4 className="mt-4">Product & Service Information</h4>
            <ul className="mb-3 ps-3">
              <li>We strive to provide accurate descriptions of our products. However, we do not guarantee that all details are error-free.</li>
              <li>Pricing is subject to change without prior notice.</li>
            </ul>

            <h4 className="mt-4">Franchise Terms</h4>
            <ul className="mb-3 ps-3">
              <li>Our franchise program requires approval. We reserve the right to decline applications based on company policies.</li>
              <li>Franchisees must comply with branding, marketing, and operational guidelines set by Riyansh Solar Power Plus.</li>
            </ul>

            <h4 className="mt-4">Payment & Refund Policy</h4>
            <ul className="mb-3 ps-3">
              <li>All payments made for our products, services, or franchise fees are strictly non-refundable.</li>
              <li>Once a transaction is completed, no refunds or cancellations will be processed.</li>
              <li>Customers and franchisees are advised to review all terms and conditions before making a purchase.</li>
            </ul>

            <h4 className="mt-4">Warranty & Liability</h4>
            <ul className="mb-3 ps-3">
              <li>We offer manufacturer warranties on our solar products; specific terms vary by product.</li>
              <li>We are not liable for damages resulting from improper installation, third-party modifications, or force majeure events.</li>
            </ul>

            <h4 className="mt-4">Intellectual Property</h4>
            <p className="mb-3">
              All website content, logos, and branding elements belong to Riyansh Solar Power Plus and cannot be copied or used without permission.
            </p>

            <h4 className="mt-4">Termination of Service</h4>
            <p className="mb-3">
              We reserve the right to terminate or suspend services if users violate these terms.
            </p>

            <h4 className="mt-4">Governing Law</h4>
            <p className="mb-3">
              These Terms are governed by the laws of India. Any disputes will be subject to the jurisdiction of courts in Thane, Maharashtra (401101).
            </p>

            <h4 className="mt-4">Contact</h4>
            <p>
              For any inquiries about these Terms & Conditions, reach out to:<br/>
              Email: <a href="mailto:Info@riyanshsolar.com">Info@riyanshsolar.com</a><br/>
              Address: Office No 3, Venkatesh Plaza, Balaji Nagar, Station Road, Bhayandar West, Thane – 401101, Maharashtra
            </p>
          </div>
        </div>
      </Section>
    </>
  );
}
